import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import AllAlertsPage from './AllAlertsPage'

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        width: "60%",
        maxHeight: '80vh',
        overflowY: 'auto'
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "-webkit-fill-available",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        maxHeight: window.innerWidth < 768 ? '80vh' : '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
}));

export default function SimpleModal({ 
    closeModal, modalTitle, infoPage, steps, toggleGlobalItem, updateInfoPage,
    deleteItem, addCategoryToInfoItem, editItemName, addItemToInfoPage, runInfoPageCleanUp, addItemToStep}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <div className="flex-apart">
                    <h2 id="simple-modal-title">{modalTitle}</h2>
                    <div className="flex-centered clickable" onClick={closeModal}>
                        <p style={{marginRight: '.5em'}}>Close Window</p>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 0C5.5875 0 0 5.5875 0 12.5C0 19.4125 5.5875 25 12.5 25C19.4125 25 25 19.4125 25 12.5C25 5.5875 19.4125 0 12.5 0ZM12.5 22.5C6.9875 22.5 2.5 18.0125 2.5 12.5C2.5 6.9875 6.9875 2.5 12.5 2.5C18.0125 2.5 22.5 6.9875 22.5 12.5C22.5 18.0125 18.0125 22.5 12.5 22.5ZM16.9875 6.25L12.5 10.7375L8.0125 6.25L6.25 8.0125L10.7375 12.5L6.25 16.9875L8.0125 18.75L12.5 14.2625L16.9875 18.75L18.75 16.9875L14.2625 12.5L18.75 8.0125L16.9875 6.25Z" fill="#10396A" />
                        </svg>
                    </div>
                </div>
                {/* <p id="simple-modal-description">
                Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
            </p> */}

                <AllAlertsPage
                    infoPage={infoPage}
                    updateInfoPage={updateInfoPage}
                    steps={steps}
                    addItemToStep={addItemToStep}
                    addCategoryToInfoItem={addCategoryToInfoItem}
                    toggleGlobalItem={toggleGlobalItem}
                    deleteItem={deleteItem}
                    editItemName={editItemName}
                    runInfoPageCleanUp={runInfoPageCleanUp}
                    addItemToInfoPage={addItemToInfoPage} />
            </div>
        </Modal>
    );
}
